import React, {useEffect, useMemo, useRef, useState} from 'react'
import classes from "./style.module.scss"
import useStyles from 'isomorphic-style-loader/useStyles'
import MeChildHeader from '../../../components/me-child-header'
import MeLoading from '../../../components/loading'
import { useDispatch, useSelector } from 'react-redux'
import { useStore } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { useQuery } from '../../../../../hooks/common'
import { FormattedMessage, useIntl } from 'react-intl'
import _ from 'lodash'
import { BigButton } from '../../../../../components/button'
import { IMAGE_GEEKO_LTD } from '../../../../../../constants'
import { updateCustomerSave } from '../../../../../../api'
import Toast from '../../../../../components/toast'
import PointsReminderModal from '../../../components/points-reminder-modal'
import { action_fetch_customer, action_fetch_message } from '../../../../../../store/actions/pages/customer'
import BottomToTop from '../../../../../components/transitions/bottom-to-top'
import { BlackMask } from '../../../../../components/mask'
import SizeRulerBox from '../../../../components/sizeRuler'
import { Iconfont } from '../../../../../components/icon/iconfont'
import formateMeaData from './formateMeasureData'

const MeasureSelect = props => {
    useStyles(classes)
    const {checkList, defaultValue, selectChange, slotSize, type, unit, item, setShowMask} = props

    const [show, setShow] = useState(false)
    const [selectItem, setSelectItem] = useState('')
    const selectRef = useRef()
    const isPreference = type == 'normal'

    useEffect(() => {
        document.addEventListener("click", checkClick, false)
        return () => {
            document.removeEventListener("click", checkClick, false)
        }
    }, [])

    useEffect(() => {
        if(defaultValue || defaultValue === 0){
            setSelectItem((isPreference? checkList?.[defaultValue]: checkList?.[unit]?.[defaultValue]) || defaultValue)
        }
    }, [defaultValue, checkList, unit] )

    const checkClick = (e) => {
        // 焦点移除关闭下拉框
        if(!selectRef.current?.contains(e?.target)){
            setShow(false)
        }
    }

    return (<React.Fragment>
        <div className={`${classes.SelectBlock} ${slotSize == 'large' ? classes.Full:''}`} 
             onClick={() => {
                if(item?.valueLabel != 'sizingRecommendation'){
                    setShowMask(item)
                } else {
                    // 打开弹窗
                    setShow(!show)
                }
            }}
             ref={selectRef}>
            <span>{selectItem? isPreference?selectItem: selectItem + (unit || ''): ''}</span>
            <img className={classes.SelectIcon} src={`${IMAGE_GEEKO_LTD}/chicme/2021-08-11/2021-08-11-select-down.png`} alt="" />
            <div className={`${classes.SelectOptionBox} ${show ? classes.SelectShow: classes.SelectHide}`}>
                {
                    checkList?.map((item, index) => {
                        const itemLabel = isPreference?item:item[unit] || ''
                        return <div className={`${classes.SelectOption} ${selectItem == itemLabel ? classes.Selected: ''}`}
                             key={itemLabel+index}
                             onClick={(e) => {
                                e?.stopPropagation()
                                selectChange(itemLabel, index)
                                setShow(false)
                             }}
                             >
                            {itemLabel}
                        </div>
                    })
                }
            </div>
        </div>

        
    </React.Fragment>)
}

export const MeasureSelectMask = props => {
    useStyles(classes)
    const { buttonText, onConfirm, onClose, show} = props
    const {
        slotTitle:title,
        unitList,
        selectList:dataList,
        slotDefaultV:defaultValue,
        unit
    } = show || {}
    const [unitSelect, setUnitSelect] = useState('')
    const [valueNow, setValueNow] = useState('')

    useEffect(() => {
        setUnitSelect(unit || unitList?.[0] || '')
    }, [unitList, unit])

    const formateStr = useMemo(() => {
        let strReg = /[A-Za-z]/g //判断数据是否存在字母
        let numReg = /[0-9]/g
        let v
        let u = valueNow?.toString()?.match(strReg)?.join('') || ''
        if(!u){
            v = valueNow
        } else {
            v = valueNow?.toString()?.match(numReg)?.join('') || 0
        }
        return {
            origin: valueNow,
            value: v,
            unit: u
        }
    }, [valueNow])

    return (<React.Fragment>
        <BottomToTop in={show} className={`${classes.MessagesContainer}`}>
            <div>
                {
                    show && <div className={classes.MeasureSelectMaskBox}>
                        <div className={classes.MaskBoxTitle}>
                            <span>{title}</span>
                            <Iconfont className={classes.Icon} onClick={e => onClose()}>&#xe7c9;</Iconfont>
                        </div>

                        <div className={classes.MaskContentBox}>
                            <div className={classes.MaskToolsBox}>
                                <div className={classes.MaskTip}>
                                    <div>
                                        <svg t="1690253237600" className={classes.TipIcon} viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="31247" width="128" height="128"><path d="M768 617.387v11.52a207.787 207.787 0 0 1-8.107 58.453L717.227 832a256 256 0 0 1-64.854 110.507 128 128 0 0 1-90.453 37.546H451.413a128 128 0 0 1-90.453-37.546l-101.547-99.414C202.24 785.493 203.947 705.707 153.6 633.6l-64.427-91.733A21.76 21.76 0 0 1 94.293 512a64.853 64.853 0 0 1 81.067 6.4L298.667 640V170.667a42.667 42.667 0 0 1 85.333 0V448a21.333 21.333 0 0 0 42.667 0v-75.093h96a128 128 0 0 1 90.88 37.546l116.48 116.054A131.84 131.84 0 0 1 768 617.387zM933.973 158.72L848.64 73.387a21.76 21.76 0 0 0-36.693 15.36V128H640V85.333A20.907 20.907 0 0 0 603.733 70.4L518.4 155.733a16.64 16.64 0 0 0 0 22.614l85.333 85.333A21.333 21.333 0 0 0 640 253.44v-40.107h170.667v40.107a21.76 21.76 0 0 0 36.693 15.36l85.333-85.333a15.787 15.787 0 0 0 1.28-24.747z" p-id="31248"></path></svg>
                                        <FormattedMessage id="swiper_to_add" defaultMessage={'Swipe to add your body information'}/>
                                    </div>
                                    <div>
                                        <FormattedMessage id="save_your_body_mea" defaultMessage={'We\'ll save your body measurements to ensure a perfect fit for your future purchases.'}/>
                                    </div>
                                </div>

                                {
                                    unitList?.length > 0 &&
                                    <div className={classes.MaskUnitBox}>
                                        <div className={classes.MaskUnitSelect}>
                                            {
                                                unitList?.map((u, i) => {
                                                    return <div className={`${classes.MaskUnitSelectItem} ${unitSelect == u? classes.MaskUnitSelected: ''}`}
                                                            key={u+i}
                                                            onClick={() => setUnitSelect(u)}>{u == 'inch' ? 'in': u}</div>
                                                })
                                            }
                                        </div>
                                    </div>
                                }

                                <div className={classes.MaskRulerBox}>
                                    <SizeRulerBox
                                        title={title}
                                        clear={!show}
                                        dataList={dataList}
                                        unit={unitSelect || unitList?.[0]}
                                        unitChange={setUnitSelect}
                                        initValue={defaultValue}
                                        setValueNow={(data) => {
                                            setValueNow(data)
                                            // setUnitSelect(formateStr(data)?.unit)
                                        }}
                                        valueNow={valueNow}
                                        hideUnit={!!formateStr?.unit}
                                        />
                                </div>
                            </div>

                            <div className={classes.MaskBoxBtnBox}>
                                <BigButton onClick={() => {
                                    const obj = formateStr
                                    onConfirm(obj?.value, obj?.unit || unitSelect)
                                }}>{buttonText || <FormattedMessage id="confirm" defaultMessage="Confirm" />}</BigButton>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </BottomToTop>
        {show && <BlackMask onClick={() => onClose()} />}
    </React.Fragment>)
}

const MeasureInput = props => {
    useStyles(classes)
    const {value, inputType, valueChange} = props

    return (
        <div className={classes.InputBlock}>
            <input
                type={inputType == 'number' ? 'text': inputType}
                value={value}
                onInput={e => {
                    if(inputType == 'number'){
                        let reg = /[a-zA-Z_\u4e00-\u9fa5]/g
                        let noNumberValue = e?.target?.value?.replace(reg, "")
                        // alert(`noNumberValue: ${e}, ${e?.target}, ${e?.target?.value}, ${noNumberValue}`)
                        valueChange(noNumberValue)
                    } else {
                        valueChange(e?.target?.value)
                    }
                }}
                onKeyDown={(event) => {
                    if(inputType == 'number'){
                        let reg = /[^a-zA-Z]/g
                        // alert(`${event.key} - ${!reg.test(event.key)} - ${event.key?.length}` )
                        if((!reg.test(event.key) && event.key?.length == 1)){
                            event.preventDefault();
                        }
                    }
                }}
                />
        </div>
    )
}

const MeasureList = props => {
    useStyles(classes)
    const { dataList, userInfo, changeData } = props
    const [showMask, setShowMask] = useState(null)

    // useEffect(() => {
    //     console.log('MeasureList: ',dataList)
    // }, [dataList])

    const selectChange = (parentTitle, valueIndex) => {
        let list = [...dataList]
        list.forEach((l) =>{
            if(l?.slotTitle == parentTitle && l?.slotDefaultV !== valueIndex){
                l.slotDefaultV = valueIndex
            }
        })
        changeData([...list])
    }

    const valueChange = (slot, value, unit) => {
        let list = [...dataList]
        list.forEach((l) =>{
            if(l?.slotTitle == slot?.slotTitle && l?.slotDefaultV != value){
                if(l?.valueLabel == 'bra'){
                    l.slotDefaultV = value + unit
                } else {
                    l.slotDefaultV = value
                }
                l.unit = unit
            }
        })
        changeData([...list])
    }

    return (
        <div className={classes.MeasureList}>
            {
                dataList?.map((item, index) => {
                    return (
                        <div className={classes.ListItem} key={item?.slotTitle + index}>
                            <div className={classes.ItemTitle}>{item?.slotTitle}</div>
                            <div className={classes.ItemTools}>
                                <MeasureSelect
                                    item={item}
                                    checkList={item?.selectList}
                                    unit={item?.unit}
                                    defaultValue={item?.slotDefaultV}
                                    slotSize={'large'}
                                    type={item?.type}
                                    setShowMask={(item) => setShowMask(item)}
                                    selectChange={(e, valueIndex) => selectChange(item?.slotTitle, valueIndex)}
                                    />
                            </div>
                        </div>
                    )
                })
            }

        <MeasureSelectMask
            show={showMask}
            onClose={() => setShowMask(null)}
            onConfirm={(data, unit) => {
                // console.log(`${showMask?.slotTitle} select `, data, unit)
                valueChange(showMask, data, unit)
                setShowMask(null)
            }}
            />
        </div>
    )
}

const MeasureInfo = props => {
    useStyles(classes)
    const {infoPart} = props
    return (
        <div className={classes.MeasureInfo}>
            <div className={classes.InfoTitle}>{infoPart.title}</div>
            <div className={classes.InfoContent}>
                <div className={classes.InfoText}>
                    {
                        infoPart?.infoList?.map((item, index) => (
                            <div className={classes.InfoLi} key={index}>
                                <div className={classes.LiTitle}>{item?.infoTitle}</div>
                                <div className={classes.LiTxt}>{item?.infoContent}</div>
                            </div>
                        ))
                    }
                </div>
                <div className={classes.InfoImage}>
                    <img src={infoPart?.imageUrl} alt=""/>
                </div>
            </div>
        </div>
    )
}

const MyMeasurements = props => {
    useStyles(classes)
    const [loading, setLoading] = useState(false)
    const [dataChange, setDataChange] = useState(false)
    const store = useStore()
    const params = useParams()
    const query = useQuery()
    const Intl = useIntl()
    const dispatch = useDispatch()

    const pageCustomer = useSelector(state => state.pageCustomer)
    const {customer, message} = pageCustomer
    const [dataList, setDataList] = useState()
    const [reminderMessage, setReminderMessage] = useState('')
    const meaData = message['M1813']? JSON.parse(message['M1813']): ''

    const infoPart = {
        title: Intl.formatMessage({id: 'measure_body_size'}),
        imageUrl: `${IMAGE_GEEKO_LTD}/chicme/2021-08-11/2021-08-11-select-body.png`,
        infoList: [
            {
                infoTitle:"1."+Intl.formatMessage({id: 'your_bust'}),
                infoContent:Intl.formatMessage({id: 'measure_body_size_bust'})
            },
            {
                infoTitle:"2."+Intl.formatMessage({id: 'your_waist'}),
                infoContent:Intl.formatMessage({id: 'measure_body_size_waist'})
            },
            {
                infoTitle:"3."+Intl.formatMessage({id: 'your_hips'}),
                infoContent:Intl.formatMessage({id: 'measure_body_size_hip'})
            }
        ]
    }

    useEffect(async () => {
        if (window.__INITIAL_STATE__) {
			// Allow the passed state to be garbage-collected
			delete window.__INITIAL_STATE__
		}
        if(customer?.id){
            setLoading(false)
        } else {
            setTimeout(() => {
                setLoading(false)
            }, 5000)
        }
        // console.log('init message: ', {meaData, message})
        if(!meaData){
            const res = await MyMeasurements.fetchData(store, params, query)
            // console.log('init: ', res)
            initData(res?.['M1813'])
        } else {
            initData()
        }
    }, [])

    // useEffect(() => {
    //     if(customer?.id){
    //         setLoading(false)
    //         initData()
    //     } else {
    //         initData()
    //         setTimeout(() => {
    //             setLoading(false)
    //         }, 5000)
    //     }
    // },[customer])

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
    }, [])

    const saveHandle = async () => {
        if(!dataChange){
            return
        }
        let obj = {}
        dataList?.forEach(item => {
            if(item?.['unit']){
                obj[item?.unitLabel] = item.unit
            }
            if(item?.slotDefaultV || item?.slotDefaultV == 0){
                if(item?.valueLabel == 'bra'){
                    // let strReg = /[A-Za-z]/g //判断数据是否存在字母
                    let numReg = /[0-9]/g
                    let v = item?.slotDefaultV?.toString()?.match(numReg)?.join('') || 0
                    // let u = item?.slotDefaultV?.toString()?.match(strReg)?.join('') || ''
                    obj[item?.valueLabel] = v
                } else {
                    obj[item?.valueLabel] = item.slotDefaultV.toString()
                }
            }
        });
        let params = {
            "customer":{"mySizeInformation": obj},
            "name":"mySizeInformation"
        }
        const response = await updateCustomerSave(params)
        setLoading(false)
        if(response?.code == 200){
            if(response?.prompt?.html){
                setReminderMessage(response?.prompt?.html)
                await dispatch(action_fetch_customer())
            } else {
                Toast(Intl.formatMessage({id: 'save_successful'}))
                await dispatch(action_fetch_customer())
            }
        } else {
            alert(response?.result || response)
        }
    }

    const initData = (data) => {
        const jsonData = data?JSON.parse(data): ''
        const initList = [
            {...formateMeaData(meaData?meaData:jsonData, 'height', Intl)},
            {...formateMeaData(meaData?meaData:jsonData, 'weight', Intl)},
            {...formateMeaData(meaData?meaData:jsonData, 'bust', Intl)},
            {...formateMeaData(meaData?meaData:jsonData, 'bra', Intl), type: 'normal',},
            {...formateMeaData(meaData?meaData:jsonData, 'waist', Intl)},
            {...formateMeaData(meaData?meaData:jsonData, 'hips', Intl)},
            {
                slotTitle: Intl.formatMessage({id: 'mea_perf'}), // 标题
                selectList:[
                    Intl.formatMessage({id:"ture_to_size"}),
                    Intl.formatMessage({id:"large"}),
                    Intl.formatMessage({id:"small"})
                ],
                valueLabel: 'sizingRecommendation',
                type: 'normal',
                slotDefaultV: 0,
                unit: '',
            },
        ]
        if(customer?.mySizeInformation){
            let list = [...initList]
            let strReg = /[A-Za-z]/g
            list?.forEach(l => {
                if(customer?.mySizeInformation?.[l?.unitLabel]){
                    l.unit = customer?.mySizeInformation?.[l?.unitLabel]
                }
                const valueFromApi = customer?.mySizeInformation?.[l?.valueLabel]
                if(valueFromApi){
                    if(l?.valueLabel == 'bra'){
                        let bValueFromApi = valueFromApi + customer?.mySizeInformation?.[l?.unitLabel]
                        const hasValueBra = l?.selectList?.some(item => item == bValueFromApi)
                        if(hasValueBra){
                            l.slotDefaultV = bValueFromApi
                        }
                    } else {
                        const hasValue = l?.selectList?.some(item => Object.values(item).includes(valueFromApi))
                        if(hasValue){
                            l.slotDefaultV = valueFromApi
                        }
                    }
                }
            })
            setDataList([...list])
        } else {
            setDataList([...initList])
        }
    }

    return (
        <div className={classes.MyMeasurementsPage}>
            <MeChildHeader name={Intl.formatMessage({id: 'my_measurements'})}/>

            <MeasureList
                dataList={dataList}
                userInfo={customer?.mySizeInformation}
                changeData={(data) => {
                    setDataChange(true)
                    setDataList(data)
                }}/>

            <MeasureInfo infoPart={infoPart} />

            <div className={classes.SignOutButton}>
                <BigButton onClick={saveHandle}><FormattedMessage id="save" defaultMessage="Save"/></BigButton>
            </div>

            {
                reminderMessage ?
                <PointsReminderModal reminderMessage={reminderMessage} onClose={() => setReminderMessage('')}/>:
                <React.Fragment></React.Fragment>
            }

            <MeLoading loading={loading}/>
        </div>
    )
}


MyMeasurements.fetchData = async (store, params, search, headers) => {
    const res = await store.dispatch(action_fetch_message('M1813'))
    return res
}

export default MyMeasurements